export default __webpack_public_path__ + "static/media/Pavel.4a669f71.png";